module.exports = __webpack_public_path__ + "static/img/index_bg_11.8ce9033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_11.jpg
// module id = F5FM
// module chunks = 9